import { render, staticRenderFns } from "./area-analysis.vue?vue&type=template&id=454c2b70&scoped=true&"
import script from "./area-analysis.vue?vue&type=script&lang=js&"
export * from "./area-analysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454c2b70",
  null
  
)

export default component.exports